import type { KeyboardEvent } from 'react'
import type { Message } from '../../api/types'
import { moveFocus } from '../../components/focus'
import { Icon } from '../../components/Icon'
import { quickReactions } from '../../lib/emoji'
import { useConversation } from './ConversationContext'

interface Props {
  message: Message
  className: string
  onReact: (emoji: string) => void
  /** + : any emoji, from the emoji picker. */
  onMore: (button: HTMLButtonElement) => void
  onKeyDown?: (event: KeyboardEvent<HTMLDivElement>) => void
}

/** The quick reactions and + for any emoji: in the message sheet, and under the Add a reaction button. */
export function ReactionBar({ message, className, onReact, onMore, onKeyDown }: Props) {
  const { me } = useConversation()
  return (
    <div
      className={className}
      role="group"
      aria-label="Choose an emoji reaction"
      onKeyDown={(event) => {
        moveFocus(event, [...event.currentTarget.querySelectorAll<HTMLElement>('button')], { next: 'ArrowRight', previous: 'ArrowLeft' })
        onKeyDown?.(event)
      }}
    >
      {quickReactions.map((option) => {
        const pressed = message.reactions.some((r) => r.emoji === option.emoji && r.userIds.includes(me.id))
        return (
          <button
            key={option.emoji}
            type="button"
            aria-pressed={pressed}
            aria-label={`${pressed ? 'Remove your' : 'React with'} ${option.label}`}
            title={option.label}
            onClick={() => onReact(option.emoji)}
          >
            {option.emoji}
          </button>
        )
      })}
      <button type="button" className="more-reactions" aria-label="More reactions" title="More reactions" onClick={(e) => onMore(e.currentTarget)}>
        <Icon name="plus" />
      </button>
    </div>
  )
}
